export const VERIFY_OTP_START = 'VERIFY_OTP_START';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_ERROR = 'VERIFY_OTP_ERROR';
export const VERIFY_OTP_END = 'VERIFY_OTP_END';
export const CLEAR_VERIFY_OTP = 'CLEAR_VERIFY_OTP';
